const ROOT_KEY = "export";

export const queryKeys = {
  reports: [ROOT_KEY, "reports"],
  byReportId: (reportId?: number) => [ROOT_KEY, "report", { reportId }],
  templates: [ROOT_KEY, "templates"],
  byTemplateId: (templateId?: number) => [ROOT_KEY, "template", { templateId }],
  deleteReport: (reportId: number) => [ROOT_KEY, "delete_report", { reportId }]
};
